import { Injectable } from "@angular/core";
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  PopoverController,
  ToastController,
} from "@ionic/angular";
import { LinkService } from "./link.service";
import { SharedService } from "./shared.service";

@Injectable({
  providedIn: "root",
})
export class SystemService {
  //efeito blur para modais
  blur = false;
  loading?: HTMLIonLoadingElement;

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public popoverCtrl: PopoverController,
    public shared: SharedService,
    public link: LinkService,
  ) {}

  public async showToast(message: string, duration?: number) {
    const toast = await this.toastCtrl.create({
      message,
      color: "success",
      duration: duration ? duration : 3000,
    });
    await toast.present();
  }

  public async showWarningToast(message: string, duration?: number) {
    const toast = await this.toastCtrl.create({
      message,
      color: "warning",
      duration: duration ? duration : 3000,
    });
    await toast.present();
  }

  public async showErrorToast(message: string, duration?: number) {
    const toast = await this.toastCtrl.create({
      message,
      color: "danger",
      duration: duration ? duration : 5000,
    });
    await toast.present();
  }

  public async showLoading() {
    this.loading = await this.loadingCtrl.create({});
    this.loading.present();
  }

  public dismissLoading() {
    if (this.loading) {
      this.loading.dismiss();
    }
  }

  async showAlert(
    typeImage: "success" | "warn" | "success-coke" | "default" | "none",
    title: string,
    description: string,
    mainLabel?: string | null,
    mainEvent?: Function | null,
    secondaryLabel?: string | null,
    secondaryEvent?: Function | null,
    hideHelpButton?: boolean,
    showClose?: boolean,
  ) {
    // const modal = await this.modalCtrl.create({
    //   component: AlertComponent,
    //   backdropDismiss: false,
    //   cssClass: typeImage,
    //   componentProps: {
    //     type: typeImage,
    //     title: title,
    //     description: description,
    //     mainLabel: mainLabel ? mainLabel : null,
    //     secondaryLabel: typeImage === 'none' && !secondaryLabel && !hideHelpButton ? 'Preciso de ajuda' : secondaryLabel ? secondaryLabel : null,
    //     showClose: showClose,
    //     mainEvent,
    //     secondaryEvent,
    //   }
    // });
    // modal.present();
    // modal.onDidDismiss().then(({ role }) => {
    //   //Condição para exibir o "Preciso de ajuda" default
    //   if (typeImage === 'none' && !secondaryLabel && role === 'secondary') {
    //     this.openSupport();
    //   }
    // });
  }

  async openSupport() {
    const loading = await this.loadingCtrl.create({});
    loading.present();
    this.shared
      .get<{ location: string }>("support/zendesk")
      .subscribe((res) => {
        loading.dismiss();
        if (res.data && res.data.location) {
          this.link.openLink(res.data.location);
        } else {
          this.showErrorAlert(res, "Atenção", true);
        }
      });
  }

  public async showErrorAlert(
    response?: any,
    title?: string,
    hideHelpButton?: boolean,
    okHandler?: () => void,
  ) {
    console.error("Ocorreu um erro: ", response);

    let msg = "Ocorreu uma falha de comunicação! Tente novamente mais tarde.";
    title = "Atenção";

    if (response && response.message) {
      msg = response.message;
    } else if (response && response.data && response.data.message) {
      msg = response.data.message;
    } else if (response && response.data && response.data.reason) {
      msg = response.data.reason;
    } else if (response && response.data && response.data.error_description) {
      msg = response.data.error_description;
    } else if (response && response.error_description) {
      msg = response.error_description;
    } else if (response && response.error_message) {
      msg = response.error_message;
    } else if (response && response.data && response.data.error_description) {
      msg = response.data.error_description;
    } else if (response && response.data && response.data.error_message) {
      msg = response.data.error_message;
    } else if (response && response.data && response.data.message) {
      msg = response.data.message;
    }

    const alert = await this.alertCtrl.create({
      header: title,
      message: msg,
      backdropDismiss: false,
      buttons: [
        {
          text: "Ok",
          handler: okHandler || (() => {}),
        },
      ],
    });
    alert.present();

    this.showAlert(
      "none",
      title,
      msg,
      "Voltar",
      null,
      null,
      null,
      hideHelpButton,
    );
  }
  public async showInfoAlert(
    title?: string,
    message?: string,
    okHandler?: () => void,
  ) {
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
      backdropDismiss: false,
      buttons: [
        {
          text: "Ok",
          handler: () => {
            if (okHandler) okHandler();
            alert.dismiss();
          },
        },
      ],
    });
    alert.present();

    this.showAlert("none", title, message, "Voltar", null, null, null);
  }
}
